import React, {useEffect} from 'react';
import {connect, useSelector} from 'react-redux';

import Authorize from 'features/auth/components/Auth/Auth';
import ContentHeader from 'features/generic/components/ContentHeader/ContentHeader';
import DashboardTableContainer from 'features/dashboard/containers/DashboardTableContainer';
import {selectCurrentUser} from 'features/users/selectors';
import {getAccount} from 'features/accounts/actions';
import {withRouter} from '../../../../utils/helpers';

const GraphContainer = React.lazy(() =>
    import('features/dashboard/containers/GraphContainer'),
);

import {
    ContentHeaderCss,
} from './styles';
import InternalAdminDashboard from './InternalAdminDashboard';

/**
 * Hide line graph from internal users for RB Account
 */
let Dashboard = (props) => {
    const currentAccountId = useSelector((state) => state.accounts.currentAccountId);
    const accounts = useSelector((state) => state.accounts.entities);

    useEffect(() => {
        // helpful to have account available in state (right after login) for authorization. Please don't remove. Will have global effects
        if (props.user.account_id) {
            props.getAccount(props.user.account_id);
        }
    }, []);

    return (
        <>
            <ContentHeader $css={ContentHeaderCss}>
                {currentAccountId &&
                    accounts?.[currentAccountId]?.organization_name &&
                    `${accounts?.[currentAccountId]?.organization_name} `}
                Overview
            </ContentHeader>
            <Authorize authorize={(user) => user.type === 'external'}>
                <GraphContainer currentAccountId={currentAccountId} {...props} />
                <DashboardTableContainer {...props} />
            </Authorize>
            <Authorize authorize={(user) => user.type !== 'external'}>
                <InternalAdminDashboard {...props} />
            </Authorize>
        </>
    );
};

export default withRouter(
    connect(
        (state, ownProps) => {
            return {
                user: selectCurrentUser(state),
            };
        },
        {
            getAccount,
        },
    )(Dashboard),
);
